import { useEffect, useState, useMemo } from 'react';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { getAllClients, getInformationPatient, getAllTypeSample, getAllExam, getAllProfile, getAllRules, saveQuoter, dowloadPdf, previewPdf, getInformationQuatation, updateQuoter, getListQuatations, savePatientMicro, getAllRulesBiExam, getAllRulesByProfile } from '../../services/microsanitaria/catalogosMic'
import { getInformationCompany, getInformationAgreement } from '../../services/company/company';
import examsValidations from '../../utils/validations/examsValidations';
import { OperationsAmounts } from '../../utils/validations/calculateWithTax';
import filterValidations from '../../utils/validations/filterValidations';
import { ConfigServer } from "../../data/config";
import { find } from 'highcharts';
import { almas, pyrsa } from '../../constant/globalConstantsTypeClients';



export const useQuoter = () => {

    //*LOCAL STORAGE
    let typeCommercialLine = localStorage.getItem('commercialLineId');
    let branch = localStorage.getItem('branchId')
    let roleUser = localStorage.getItem('roleUser');
    let nameBranch = localStorage.getItem('branchName')
    let url_helen = localStorage.getItem('url_helen');


    const history = useHistory();
    const [createSweet, sweetConfirmation, , , , , sweetConfirmRepeatExam, sweetConfirmationChangeClient] = useSweetAlert();

    const [listCompanies, setListCompanies] = useState([])
    const [checkTypeClient, setCheckTypeClient] = useState(4);
    const [listAddress, setListAddress] = useState([])


    //*SELECT TYPE CLIENT
    const [informationPatient, setInformationPatient] = useState([]);
    const [informationCompany, setInformationCompany] = useState([]);

    //*INPUTS SEARCH MICRO
    const [searchSampleState, setSearchSampleState] = useState([]);
    const [examProfileState, setExamProfileState] = useState([]);

    //*RULES
    const [listRules, setListRules] = useState([]);

    //*TOGGLE EXAMS
    const [modalExams, setModalExams] = useState(false);
    const [listExams, setListExams] = useState([]);

    //*DETAIL QUOTER
    const [viewQuoter, setViewQuoter] = useState(false)
    const [loadingCreate, setLoadingCreate] = useState(false)

    //*CONFIGURATION BUTTONS AND TABLE
    const [isHovered, setIsHovered] = useState(false);
    const [isHoveredClean, setIsHoveredClean] = useState(false);
    const [hoveredColumn, setHoveredColumn] = useState("");
    const [expandedRow, setExpandedRow] = useState(null);

    //*VIEW QUATATION
    const [informationQuatation, setInformationQuatation] = useState([])

    //*CONFIGURATION AGREEMENT
    const [listAgreement, setListAgreement] = useState([]);

    // * MODAL PATIENT
    const [modalPatient, setModalPatient] = useState(false);
    const [loadingPatientMicro, setLoadingPatientMicro] = useState(false);

    // *PDF PREVIEW QUOTER
    const [pdfPreviewQuoter, setPdfPreviewQuoter] = useState(null);
    const [showPreviewPdfQuoter, setShowPreviewPdfQuoter] = useState(false);
    const [loadingPdfQuoter, setLoadingPdfQuoter] = useState(false);


    //* PREVIEW 
    const [pdfPreviewSamplingSheet, setPdfPreviewSamplingSheet] = useState(null);
    const [showPreviewSamplingSheet, setShowPreviewSamplingSheet] = useState(false);
    const [loadingPdf, setLoadingPdf] = useState(false);
    const [currentQuoter, setCurrentQuoter] = useState(null);
    const [currentCode, setCurrentCode] = useState(null);
    const [optionsTotal, setOptionsTotal] = useState({
        subtotal: 0,
        tax: 0,
        total: 0
    });

    const [total_tax, setTotal_tax] = useState(0)

    //* ALERT MODAL 
    const [showAlertNorma, setShowAlertNorma] = useState(false);
    const [messageNorma, setMessageNorma] = useState("");

    //* DIAlOG NORM
    const [modalNorms, setModalNorms] = useState(false);
    const [listNorms, setListNorms] = useState([]);
    const [detailNorm, setDetailNorm] = useState(null);

    //* Delete dialog
    const [modalAlert, setModalAlert] = useState(false);
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);
    const [sampleDeleteIndex, setSampleDeleteIndex] = useState(null);
    const [sampleDeleteName, setSampleDeleteName] = useState("");


    //* DELETE DETERMINATION

    const [deleteType, setDeleteType] = useState(null);

    const [detDeleteData, setDetDeleteData] = useState({
        indexSample: null,
        id_exam: null,
        id_profile: null,
        name: ""
    });


    //? CUSTOM ALERT GLOBAL
    const [customAlert, setCustomAlert] = useState({
        visible: false,
        mode: "alert",
        type: "info",
        title: "",
        message: "",
        onAccept: null,
        onCancel: null
    });

    //*FOMR MIC
    const [formQuoterMic, setFormQuoterMic] = useState({
        searchPatientState: [],
        id_company: null,
        id_patient: null,
        id_type_client: null,
        observations: "",
        is_sampling: false,
        date_sample_up: moment().format("D/M/YYYY hh:mm"),
        date_sample: null,
        type_sample_select: null,
        id_exam_temp: null,
        list_type_samples: [],
        statusQuoter: false,
        id_quatation: 0,
        code_quatation: null,
        valid_sampling: false,
        search_quatation: null,
        searchPatientQuoter: [], // ? FIND CODE QUOTER
        start_date: null,
        end_date: null,
        id_patient_search: null,
        id_company_search: null,
        id_agreement: null,
        id_address: null
    });


    // * FORM PATIENT
    const [formPatient, setFormPatient] = useState({
        id_gender: 0,
        id_state_patient: 1,
        id_municipality_patient: 1,
        id_social_gender_patient: null,
        id_blood_type: null,
        id_tax_regime: null,
        id_use_cfdi: null,
        paternal_surname: null,
        maternal_surname: null,
        name: null,
        birthday: "2025-01-01",
        age: 0,
        curp: "CURPDEFAULT",
        address_patient: "",
        cp_patient: "00000",
        phone: null,
        email_patient: null,
        membership: "0",
        cardnumber: "DEFAULT",
        rfc: "DEFAULT",
        type_person: 1,
        new_social_gender: "",
        scan_ine_check: false,
        setFileINE: "DEFAULT",
        nss: 0,
        matricula_buap: ""
    })

    useEffect(() => {
        let mfrom = (formQuoterMic.start_date === null) ? moment().format("YYYY-MM-DD") : moment(formQuoterMic.start_date).format("YYYY-MM-DD");
        let mto = (formQuoterMic.end_date === null) ? moment().format("YYYY-MM-DD") : moment(formQuoterMic.end_date).format("YYYY-MM-DD");
        getRules()
        getClients(3)
        getSearchFilter(`from=${mfrom}&to=${mto}`)
    }, [])

    const formatAmount = (amount, decimals) => {
        return parseFloat(
            (Math.trunc(amount * 100000000) / 100000000).toFixed(decimals),
        );
    }
    //#region CUSTOM ALERT

    const showCustomAlert = (type, title, message) => {

        console.log("🚨 showCustomAlert ejecutado");

        setCustomAlert({
            visible: true,
            mode: "alert",
            type,
            title,
            message,
            onAccept: () => {
                setCustomAlert(prev => ({
                    ...prev,
                    visible: false
                }));
            },
            onCancel: null
        });

    };

    const showCustomAlertConfirm = ({
        type = "warning",
        title,
        message,
        buttonText = "Aceptar",
        cancelText = "Cancelar"
    }) => {

        return new Promise((resolve) => {

            setCustomAlert({
                visible: true,
                mode: "confirm",
                type,
                title,
                message,
                buttonText,
                cancelText,

                onAccept: () => {

                    setCustomAlert(prev => ({
                        ...prev,
                        visible: false
                    }));

                    resolve(true);

                },

                onCancel: () => {

                    setCustomAlert(prev => ({
                        ...prev,
                        visible: false
                    }));

                    resolve(false);

                }

            });

        });

    };
    //#endregion

    //*CALCULATE AMOUNT
    useMemo(() => {

        if (formQuoterMic.list_type_samples?.length > 0) {

            let subtotal = 0;
            let taxes = 0;
            let total = 0;
            let _valid = ""

            formQuoterMic.list_type_samples.forEach(_find => {

                if (_find?.list_determinations !== null && _find?.list_determinations.length > 0) {

                    _find.list_determinations.forEach(_search => {

                        setTotal_tax(_search?.value_iva)
                        switch (_search?.config_iva) {
                            case true:

                                if (_search?.discount !== 0) {

                                    _valid = OperationsAmounts(_find?.cant, _search?.price_discount, true, _search?.value_iva, _search?.discount)

                                }
                                else _valid = OperationsAmounts(_find?.cant, _search?.price, true, _search?.value_iva, _search?.discount_par)

                                // ? TOTAL
                                _search.discount_tota = _valid.total
                                _search.can_total = _valid.total
                                subtotal += _valid.subtotal;
                                taxes += _valid.total_tax
                                total += _valid.total
                                break;

                            default:

                                if (_search?.discount !== 0) {
                                    _valid = OperationsAmounts(_find?.cant, _search?.price_discount, false, _search?.value_iva, _search?.discount)

                                }
                                else _valid = OperationsAmounts(_find?.cant, _search?.price, false, _search?.value_iva, _search?.discount_par)

                                // ? TOTAL
                                _search.discount_tota = _valid.total
                                _search.can_total = _valid.total
                                subtotal += _valid.subtotal;
                                taxes += _valid.total_tax
                                total += _valid.total
                                break;
                        }
                    });
                }
            })
            // console.log("🚀 ~ useMemo ~ total:", total)


            setOptionsTotal({
                subtotal: formatAmount(subtotal, 2),
                tax: formatAmount(taxes, 2),
                total: formatAmount(total, 2)
            })
        }
    }, [formQuoterMic])

    //*TYPE CLIENT
    const getClients = async (_type) => {
        const company = await getAllClients(3);

        if (company?.length > 0) {
            const list = company?.map(_find => {
                return {
                    value: _find?.id_company,
                    label: _find?.code + "-" + _find?.name,
                }
            });
            setListCompanies(list);
        }
    }

    //*TYPE RULES
    const getRules = async (_type) => {
        const rules = await getAllRules(_type);

        if (rules?.length > 0) {
            const list = rules?.map(_find => {
                return {
                    code: _find?.id_mic_nom,
                    name: _find?.name,
                }
            });
            setListRules(list);
        }
        else setListRules([]);
    }

    //*TYPE SERVICE
    const handleChangeTypeClient = (_typeClient, validClient = -1) => {

        if (validClient === -1 && _typeClient !== 4) {
            sweetConfirmationChangeClient("Al cambiar el tipo de ingreso, perderas los datos ingresados", "Estas seguro de realizar esta acción", "warning", _typeClient, true, handleChangeTypeClient)
            return;
        }

        if (_typeClient === 4) {
            let mfrom = (formQuoterMic.start_date === null) ? moment().format("YYYY-MM-DD") : moment(formQuoterMic.start_date).format("YYYY-MM-DD");
            let mto = (formQuoterMic.end_date === null) ? moment().format("YYYY-MM-DD") : moment(formQuoterMic.end_date).format("YYYY-MM-DD");
            getSearchFilter(`from=${mfrom}&to=${mto}`)
        }

        if (!validClient) {
            return;
        }
        else {
            setCheckTypeClient(_typeClient)
            if (_typeClient === 1) {

                setFormQuoterMic({
                    ...formQuoterMic,
                    id_company: null,
                    id_patient: null,
                    id_type_client: null,
                    observations: "",
                    is_sampling: false,
                    date_sample_up: moment().format("D/M/YYYY hh:mm"),
                    date_sample: null,
                    type_sample_select: null,
                    id_exam_temp: null,
                    list_type_samples: [],
                    listQuoterTest: [],
                    statusQuoter: false,
                    id_quatation: 0,
                    code_quatation: null,
                    valid_sampling: false,
                    search_quatation: null,
                    id_address: null

                });
                setInformationCompany([])
                setListAddress([])

                setOptionsTotal({
                    subtotal: 0,
                    tax: 0,
                    total: 0
                });
                setViewQuoter(false);
            }
            else {
                setFormQuoterMic({
                    ...formQuoterMic,
                    id_company: null,
                    id_patient: null,
                    id_type_client: null,
                    observations: "",
                    is_sampling: false,
                    date_sample_up: moment().format("D/M/YYYY hh:mm"),
                    date_sample: null,
                    type_sample_select: null,
                    id_exam_temp: null,
                    list_type_samples: [],
                    listQuoterTest: [],
                    statusQuoter: false,
                    id_quatation: 0,
                    code_quatation: null,
                    valid_sampling: false,
                    search_quatation: null,
                    searchPatientState: [],
                    id_address: null
                });
                setInformationPatient([])
                setInformationCompany([])
                setListAddress([])
                setOptionsTotal({
                    subtotal: 0,
                    tax: 0,
                    total: 0
                });
                setViewQuoter(false);

            }
        }
    }

    //*TYPE PARTICULAR
    const handleChangePatient = async (e, unique_uuid = 0) => {
        const patient_id = e?.target?.value;

        let alternative_methods = "";

        if (unique_uuid !== 0) {
            alternative_methods = `?unique_uuid=${unique_uuid}`;
        }

        if (patient_id !== 0 && patient_id !== null && patient_id !== "" && patient_id !== "0") {
            const getPatient = await getInformationPatient(patient_id, alternative_methods);

            if (getPatient !== null) {
                setInformationPatient({
                    birthday: getPatient?.birthday ?? "----",
                    phone: getPatient?.phone ?? "----",
                    email: getPatient?.email ?? "----",
                    name: getPatient?.name ?? "----",
                    paternal_surname: getPatient?.paternal_surname ?? "----",
                    maternal_surname: getPatient?.maternal_surname ?? "----",
                    client: (getPatient?.name + " " + getPatient?.paternal_surname + " " + getPatient?.maternal_surname)
                });

                setFormQuoterMic({
                    ...formQuoterMic,
                    id_patient: getPatient?.id_patient,
                });
            }
        }
        else {
            setInformationPatient([])
            setCheckTypeClient(1)
            setFormQuoterMic({
                ...formQuoterMic,
                id_patient: null,
            });
        }
    }


    //*COMPANY
    const handleChangeCompany = async (e) => {
        if (e !== null && e?.value !== undefined) {

            const companyChanged =
                formQuoterMic.id_company !== null &&
                formQuoterMic.id_company !== e.value;

            if (
                companyChanged &&
                formQuoterMic.list_type_samples.length > 0
            ) {

                const confirmed = await showCustomAlertConfirm({
                    type: "warning",
                    title: "Cambiar empresa",
                    message: "Al cambiar la empresa se eliminarán todas las muestras y determinaciones agregadas. ¿Deseas continuar?",
                    buttonText: "Sí, cambiar",
                    cancelText: "Cancelar"
                });

                if (!confirmed) {
                    return;
                }

                clearQuotationData();
            }
            const getList = await getInformationCompany(e.value);
            // console.log("getList1", getList);

            if (getList !== null) {
                const getAgreement = await getInformationAgreement(e.value);
                if (getAgreement !== null) {
                    const list = getAgreement?.map(_find => {
                        return {
                            value: _find?.id_agreement,
                            label: _find?.code,
                        }
                    });
                    setListAgreement(list);
                }

                const list = getList.listCompanyBusinessNames?.map(_find => {
                    return {
                        "name": _find?.business_name ?? "----",
                        "code": getList?.code ?? "----",
                        "phone": _find?.phone ?? "----",
                        "name_company_turn": getList?.name_company_turn ?? "----",
                        "contact_email": _find?.email ?? "----",
                        "require_invoice": getList?.require_invoice ? "Si" : "No",
                        "payment": (getList?.payment_by_company && getList?.payment_by_patient) ? "Ambas partes" : (getList?.payment_by_company) ? "Empresa" : "Paciente" ?? "----"
                    }
                });

                const addressList = [];
                getList.listCompanyBusinessNames.forEach((_find, key) => {
                    if (_find?.address) {
                        addressList.push({
                            label: _find.address,
                            value: _find.id_company_business_name,
                            id_company_business_name: _find.id_company_business_name

                        });
                    }

                    if (_find?.arrayAddressCompany && _find?.arrayAddressCompany.length > 0) {
                        _find.arrayAddressCompany.forEach((_addr, idx) => {
                            addressList.push({
                                label: _addr?.address ?? "----",
                                value: _addr?.id_address_company ?? idx + 1,
                                id_address_company: _addr?.id_address_company
                            });
                        });
                    }
                });

                if (addressList.length === 0) {
                    addressList.push({
                        label: "Por definir",
                        value: 0,
                    });
                }

                setListAddress(addressList);
                setInformationCompany(list);

                setFormQuoterMic(prev => ({
                    ...prev,
                    id_company: getList?.id_company,
                    id_agreement: null,
                    id_address: null
                }));
            }
        }
        else {

            setInformationCompany([]);
            setListAgreement([]);

            setFormQuoterMic(prev => ({
                ...prev,
                id_company: null,
                id_agreement: null,
                id_address: null
            }));
        }
    }

    //*AGREEMENT
    const handleChangeAddress = (e) => {
        const _address = e;

        if (e !== null && e?.value !== undefined && e?.value !== "") {

            setFormQuoterMic({
                ...formQuoterMic,
                id_address: _address,
            });

        }

    }

    const handleChangeAgreement = async (e) => {

        const agreementChanged =
            formQuoterMic.id_agreement?.value !== e?.value;

        const hasData = formQuoterMic.list_type_samples.length > 0;

        if (agreementChanged && hasData) {

            const confirmed = await showCustomAlertConfirm({
                type: "warning",
                title: "Cambiar convenio",
                message: "Al cambiar el convenio se eliminarán todas las muestras y determinaciones agregadas. ¿Deseas continuar?",
                buttonText: "Sí, cambiar",
                cancelText: "Cancelar"
            });

            if (!confirmed) {
                return;
            }

            clearQuotationData();
        }

        setFormQuoterMic(prev => ({
            ...prev,
            id_agreement: e
        }));
    }

    //*OBSERVATIONS
    const handleChangeComments = async (e) => {
        const _comment = e?.target?.value;

        if (e !== null && e?.target?.value !== undefined) {
            setFormQuoterMic({
                ...formQuoterMic,
                observations: _comment,
            });
        }
        else {
            setFormQuoterMic({
                ...formQuoterMic,
                observations: null,
            });
        }
    }

    //*REQUIERE IS SAMPLING
    const handleChangeSampling = async (e) => {
        const _check = e?.target?.checked;

        if (_check) {
            setFormQuoterMic({
                ...formQuoterMic,
                is_sampling: _check,
            });

        } else {
            setFormQuoterMic({
                ...formQuoterMic,
                is_sampling: false,
            });
        }
    }

    //*DATE
    const handlePickerValues = async (e) => {
        if (e && moment.isMoment(e)) {

            const formattedDate = e?.format('YYYY-MM-DD HH:mm');

            setFormQuoterMic({
                ...formQuoterMic,
                date_sample: formattedDate,
            });
        }
        else {
            setFormQuoterMic({
                ...formQuoterMic,
                date_sample: null,
            });
        }
    }

    //*TYPE OF SAMPLE
    const handleSelectMuestra = async (e) => {
        const _determination = e?.target?.value;

        if (_determination !== 0 && _determination !== null && _determination !== "") {

            if (
                formQuoterMic.id_company > 0 &&
                formQuoterMic.id_agreement === null
            ) {
                createSweet(
                    "create",
                    "warning",
                    "Determinación",
                    "Se debe seleccionar un convenio de la empresa para continuar."
                );
                return;
            }

            const getType = await getAllTypeSample();

            if (getType !== null) {
                const list = getType?.map(_find => {
                    if (_determination === parseInt(_find?.id_mic_type_sample)) {
                        return {
                            sample_name: _find?.name,
                            origin: _find?.origin,
                            id_mic_type_sample: _find?.id_mic_type_sample
                        };
                    }
                    return null;
                });

                const _find = list.filter(x => x !== null);

                if (_find.length > 0) {

                    const listOrders = formQuoterMic.list_type_samples;

                    _find.forEach(item => {
                        listOrders.push({
                            id: item?.id_mic_type_sample,
                            id_quoter_type_samples: null,
                            list_determinations: [],
                            name_sample: item?.sample_name,
                            id_type_client: 0,
                            observations: "",
                            price_sample: 0,
                            cant: 1,
                            id_new: Date.now()
                        });
                    });
                    setSearchSampleState([])
                    setFormQuoterMic({
                        ...formQuoterMic,
                        list_type_samples: listOrders
                    });
                }
                else {
                    setSearchSampleState([])
                    setFormQuoterMic({
                        ...formQuoterMic,
                        list_type_samples: []
                    });
                }
            }
        }
        else setSearchSampleState([])
    }

    // * RULES PROFILES
    const formatProfileRules = (rules, defaultRules = []) => {
        if (!Array.isArray(rules) || rules.length === 0) {
            return Array.isArray(defaultRules) ? defaultRules : [];
        }

        return rules.flatMap(exam =>
            exam.rules.map(rule => ({
                code: rule.id_exam_rule,
                name: rule.norm
            }))
        );
    };

    //*TYPE DETERMINACION EXAMS AND PROFILES
    const handleSelectDetermination = async (e, _key) => {

        let determination = e?.target?.value;

        if (determination !== 0 && determination !== null && determination !== "") {

            determination = determination.split('-');

            let _idTest = determination[0];
            let _typeTest = determination[1];
            let _nameTypeTest = _typeTest === "0" ? "Exam" : "Profile";

            if (_nameTypeTest === "Profile") {
                //!GLOBALES
                let _id_patient = 0;
                let _id_company = 0;

                console.log("PACIENTE", formQuoterMic.id_patient);
                console.log("EMPRESA", formQuoterMic.id_company);
                //!VALIDATE TYPE COMPANY
                _id_company = (formQuoterMic.id_company ?? 0) !== 0 ? formQuoterMic.id_company : 0;
                _id_patient = _id_company === 0 ? formQuoterMic.id_patient : 0;
                let _alternative_method = "";
                let _idAgreement = ((formQuoterMic.id_company === null || formQuoterMic.id_company === 0) ? "" : formQuoterMic.id_agreement.value)
                console.log("_id_patient", _id_patient);
                console.log("_id_company", _id_company);
                //!DETERMINATION
                if (_id_patient !== 0 || _id_company !== 0) {
                    let _listNew = null;
                    let _listTemp = formQuoterMic.list_type_samples
                    let findDeterminations = _listTemp[_key];

                    if (findDeterminations) {
                        _listTemp.map((x, ind) => {
                            if (ind === _key) {
                                _listNew = findDeterminations?.list_determinations;
                            }
                            return x;
                        });
                    } else {
                        _listNew = [];
                    }
                    setFormQuoterMic({
                        ...formQuoterMic,
                        list_type_samples: _listTemp
                    });

                    // ? CONFIGURATION AGREEMENT
                    if (formQuoterMic.id_agreement !== null) {
                        _alternative_method = (_alternative_method === "" ? `&id_agreement=${_idAgreement}` : "");
                    }

                    const getTypeAllProfile = await getAllProfile(_idTest, branch, typeCommercialLine, _id_patient, _id_company, _alternative_method);

                    if (getTypeAllProfile !== null) {

                        //!RULES

                        const getProfileRules = await getAllRulesByProfile(
                            getTypeAllProfile?.id_profile ?? 0
                        );
                        const profileNorms = formatProfileRules(
                            getProfileRules,
                            listRules
                        );

                        const examsWithoutRules = getProfileRules.filter(
                            x => !x.rules || x.rules.length === 0
                        );

                        if (
                            (url_helen === almas || url_helen === pyrsa) &&
                            examsWithoutRules.length > 0
                        ) {

                            const examNames = examsWithoutRules
                                .map(x => {
                                    const exam = getTypeAllProfile.listExams?.find(
                                        e => e.id_exam === x.id_exam
                                    );

                                    return exam?.name || `ID ${x.id_exam}`;
                                })
                                .join(", ");

                            setMessageNorma(
                                `No se puede agregar el perfil <strong>${getTypeAllProfile?.name}</strong> porque los siguientes estudios requieren una norma asociada:<br/><br/><strong>${examNames}</strong>`
                            );

                            setShowAlertNorma(true);
                            setExamProfileState([]);
                            return;
                        }

                        let _id_agreement = null;

                        if (formQuoterMic.id_agreement !== null) {

                            _id_agreement = getTypeAllProfile?.agreement


                            if (_id_agreement === 0 || _id_agreement === null) {
                                createSweet("create", "warning", "Convenio", `El estudio ${getTypeAllProfile?.name ?? "-------"} no se encuentra dentro del convenio seleccionado`);
                                setExamProfileState([])
                                return;
                            }
                        }

                        if (getTypeAllProfile.code === 404) {
                            createSweet("create", "warning", "Determinaciones", getTypeAllProfile.data.msg);
                            setExamProfileState([])
                            return;
                        }
                        if (getTypeAllProfile.code === 409) {
                            createSweet("create", "warning", "Determinaciones", getTypeAllProfile.data.msg);
                            setExamProfileState([])
                            return;
                        }
                        if (getTypeAllProfile.price === 0) {
                            createSweet("create", "warning", "Determinaciones", `No se encontro un precio para ${getTypeAllProfile.name}`);
                            setExamProfileState([])
                            return;
                        }
                        setExamProfileState([])

                        let _id_agreementP = null;
                        let price_sample = 0;
                        let _porcentaje_discount = 0;
                        let _descuento_cifra = 0;
                        let _contract_number = null
                        let _price_sample = 0;


                        price_sample += parseFloat(getTypeAllProfile?.price.toFixed(2));
                        let newValidations = {};
                        let validTest = examsValidations(formQuoterMic, newValidations, _key, null, _idTest, getTypeAllProfile.listExams, getTypeAllProfile.name);

                        if (validTest !== -1 && validTest !== 2) {
                            sweetConfirmRepeatExam("La determinación ya existe en el tipo de muestra", validTest.message_validation, "warning");
                            price_sample -= parseFloat(getTypeAllProfile.price.toFixed(2));
                            return;
                        }

                        // ! AGREEMENT 
                        if (_id_company > 0) {
                            if (getTypeAllProfile?.agreement !== null) {

                                getTypeAllProfile.agreement.forEach(_find => {

                                    _porcentaje_discount = _find?.percentage;
                                    _id_agreementP = _find?.id_agreement;
                                    let _discount = (getAllProfile?.price * _porcentaje_discount) / 100;
                                    _descuento_cifra = !isNaN(_discount) ? parseFloat(_discount.toFixed(2)) : 0;
                                    price_sample = price_sample - _descuento_cifra;
                                    _contract_number = _find?.contract_number
                                    _price_sample = _find.price;

                                });
                            }
                        }

                        let _new_determination = false;

                        if (formQuoterMic.id_quatation > 0) {
                            _new_determination = true;
                        }

                        _listNew.push({
                            id_profile: getTypeAllProfile?.id_profile ?? 0,
                            id_exam: null,
                            id_price: getTypeAllProfile?.id_price ?? 0,
                            price: _id_company > 0 ? _price_sample : getTypeAllProfile?.price ?? 0,
                            price_discount: _id_company > 0 ? price_sample : getTypeAllProfile?.price - _descuento_cifra,
                            name: getTypeAllProfile?.name ?? "",
                            code: getTypeAllProfile?.code ?? "",
                            abbreviation: getTypeAllProfile?.abbreviation ?? "",
                            config_iva: getTypeAllProfile?.config_iva ?? 0,
                            value_iva: getTypeAllProfile?.value_iva ?? 0,
                            listExams: getTypeAllProfile?.listExams ?? 0,
                            id_agreement: _id_agreementP,
                            new_determination: _new_determination,
                            discount: !isNaN(_porcentaje_discount) ? parseFloat(_porcentaje_discount.toFixed(2)) : 0,
                            id_quoter_determination: null,
                            list_nom: [],
                            observations_det: "",
                            discount_par: 0,
                            contract_number: _contract_number,
                            listNorm: profileNorms,
                            profileRulesDetail: getProfileRules,
                            // ids_mic_noms: profileNorms.map(x => x.code),
                            ids_mic_noms: url_helen === almas
                                ? profileNorms.map(x => x.code)
                                : [],
                            is_edit: formQuoterMic.code_quatation === null ? 0 : 1
                        });


                        let list_type_sample_temp = formQuoterMic.list_type_samples;
                        let findDeterminations = list_type_sample_temp[_key];
                        let _validDeterminaciones = false;

                        if (findDeterminations) {

                            findDeterminations.list_determinations = _listNew;
                            findDeterminations.price_sample += price_sample;
                            list_type_sample_temp.map((x, inde) => {
                                if (inde === _key) {
                                    x = findDeterminations;
                                }
                                return x;
                            });
                            _validDeterminaciones = findDeterminations.list_determinations.length > 0 ? true : false

                        }
                        else {
                        }
                        setExamProfileState([]);
                        setFormQuoterMic({
                            ...formQuoterMic,
                            list_type_samples: list_type_sample_temp,
                            valid_sampling: _validDeterminaciones
                        });
                    }
                    else setExamProfileState([])

                }
            }
            else {
                let _id_patient = 0;
                let _id_company = 0;
                let _alternative_method = "";

                let _idAgreement = ((formQuoterMic.id_company === null || formQuoterMic.id_company === 0) ? "" : formQuoterMic.id_agreement.value)

                //!VALIDATE TYPE COMPANY
                _id_company = (formQuoterMic.id_company ?? 0) !== 0 ? formQuoterMic.id_company : 0;
                _id_patient = _id_company === 0 ? formQuoterMic.id_patient : 0;


                if (_id_patient !== 0 || _id_company !== 0) {
                    //!DETERMINATION
                    let _listNew = null
                    let _listTemp = formQuoterMic.list_type_samples
                    let findDeterminations = _listTemp[_key];

                    if (findDeterminations) {
                        _listTemp.map((x, ind) => {
                            if (ind === _key) {
                                _listNew = findDeterminations.list_determinations;
                            }
                            return x;
                        });
                    } else _listNew = [];

                    setFormQuoterMic({
                        ...formQuoterMic,
                        list_type_samples: _listTemp
                    });

                    // ? CONFIGURATION AGREEMENT
                    if (formQuoterMic.id_agreement !== null) {

                        _alternative_method = (_alternative_method === "" ? `?id_agreement=${_idAgreement}` : "");
                    }

                    //!METHOD
                    const getTypeAllExam = await getAllExam(_idTest, branch, typeCommercialLine, _id_patient, _id_company, _alternative_method);

                    if (getTypeAllExam !== null) {

                        if (getTypeAllExam?.agreement != null) {

                            let _id_agreement = null;
                            let _agreement = getTypeAllExam?.agreement;

                            _id_agreement = _agreement?.id_agreement;

                            if (_id_agreement === 0) {
                                createSweet("create", "warning", "Convenio", `El estudio ${getTypeAllExam?.name} no se encuentra dentro del convenio seleccionado`);
                                setExamProfileState([])
                                return;
                            }
                        }

                        if (getTypeAllExam.code === 404) {
                            createSweet("create", "warning", "Determinaciones", getTypeAllExam.data.msg);
                            setExamProfileState([])
                            return;
                        }
                        if (getTypeAllExam.code === 409) {
                            createSweet("create", "warning", "Determinaciones", getTypeAllExam.data.msg);
                            setExamProfileState([])
                            return;
                        }

                        if (getTypeAllExam.price === 0) {
                            createSweet("create", "warning", "Determinaciones", `No se encontro un precio para ${getTypeAllExam.name}`);
                            setExamProfileState([])
                            return;
                        }
                        setExamProfileState([])
                        const getBiRul = await getAllRulesBiExam(getTypeAllExam?.id_exam ?? 0);
                        if (
                            (url_helen === almas || url_helen === pyrsa) &&
                            (!getBiRul || getBiRul.length === 0)
                        ) {
                            setMessageNorma(
                                `No se puede agregar el estudio <strong>${getTypeAllExam?.name}</strong> porque requiere al menos una norma asociada.`
                            );

                            setShowAlertNorma(true);
                            setExamProfileState([]);
                            return;
                        }

                        let _id_agreement = null;
                        let _porcentaje_discount = 0;
                        let _descuento_cifra = 0;
                        let price_sample = 0;
                        let _contract_number = null
                        let _price_sample = 0;

                        price_sample += parseFloat(getTypeAllExam.price.toFixed(2));

                        let newValidations = {};
                        let validTest = examsValidations(formQuoterMic, newValidations, _key, _idTest);

                        if (validTest !== -1 && validTest !== 2) {
                            sweetConfirmRepeatExam("La determinación ya existe en el tipo de muestra", validTest.message_validation, "warning");
                            price_sample -= parseFloat(getTypeAllExam.price.toFixed(2));
                            return;
                        }

                        if (_id_company > 0) {

                            if (getTypeAllExam?.agreement != null) {

                                let _agreement = getTypeAllExam?.agreement;
                                _porcentaje_discount = _agreement.percentage;
                                _id_agreement = _agreement.id_agreement;
                                let _discount = (getTypeAllExam?.price * _porcentaje_discount) / 100;
                                let _descuento_cifra = !isNaN(_discount) ? parseFloat(_discount.toFixed(2)) : 0;
                                price_sample = price_sample - _descuento_cifra;
                                _contract_number = _agreement?.contract_number
                                _price_sample = _agreement?.price
                            }
                        }

                        let _new_determination = false;

                        if (formQuoterMic.id_quatation > 0) {
                            _new_determination = true;
                        }


                        _listNew.push({
                            id_profile: null,
                            id_exam: getTypeAllExam?.id_exam ?? 0,
                            id_price: getTypeAllExam?.id_price ?? 0,
                            price: _id_company > 0 ? _price_sample : getTypeAllExam?.price ?? 0,
                            price_discount: _id_company > 0 ? price_sample : getTypeAllExam?.price - _descuento_cifra,
                            name: getTypeAllExam?.name ?? "",
                            code: getTypeAllExam?.code ?? "",
                            abbreviation: getTypeAllExam?.abbreviation ?? "",
                            config_iva: getTypeAllExam?.config_iva ?? 0,
                            value_iva: getTypeAllExam?.value_iva ?? 0,
                            id_agreement: _id_agreement,
                            new_determination: _new_determination,
                            discount: !isNaN(_porcentaje_discount) ? parseFloat(_porcentaje_discount.toFixed(2)) : 0,
                            id_quoter_determination: null,
                            list_nom: [],
                            observations_det: "",
                            discount_par: 0,
                            contract_number: _contract_number,
                            is_edit: formQuoterMic.code_quatation === null ? 0 : 1,

                            listNorm: getBiRul.map(_find => ({
                                code: _find?.id_exam_rule,
                                name: _find?.norm
                            })),
                            ids_mic_noms: url_helen === almas
                                ? getBiRul.map(_find => _find?.id_exam_rule)
                                : []
                            // ids_mic_noms: getBiRul.map(_find => _find?.id_exam_rule)
                        });

                        let list_type_sample_temp = formQuoterMic.list_type_samples;
                        let findDeterminations = list_type_sample_temp[_key];
                        let _validDeterminaciones = false;

                        if (findDeterminations) {
                            findDeterminations.list_determinations = _listNew;
                            findDeterminations.price_sample += price_sample;
                            list_type_sample_temp.map((x, inde) => {
                                if (inde === _key) {
                                    x = findDeterminations;
                                }
                                return x;
                            });
                            _validDeterminaciones = findDeterminations.list_determinations.length > 0 ? true : false
                        }
                        else {
                        }
                        setExamProfileState([])
                        setFormQuoterMic({
                            ...formQuoterMic,
                            list_type_samples: list_type_sample_temp,
                            valid_sampling: _validDeterminaciones
                        });
                    }
                    else setExamProfileState([])
                }
                else setExamProfileState([])

            }
        }
        else setExamProfileState([])
    }

    //*OBSERVATIONS DETERMINATIONS
    const handleObservations = (e, _id_exam, _id_profile = null, _id_type_sample) => {

        if (e !== null && e?.target?.value !== undefined) {

            let _value = e?.target?.value;
            let _arrayComment = formQuoterMic.list_type_samples;
            let _find = _arrayComment.find(x => x.id === parseInt(_id_type_sample));

            if (_find) {
                const _findList = _find.list_determinations;
                _findList.forEach(x => {
                    if ((_id_exam !== null && x?.id_exam === _id_exam) ||
                        (_id_exam === null && x?.id_profile === _id_profile)) {
                        x.observations_det = _value;
                    }
                });
            }
            setFormQuoterMic({
                ...formQuoterMic,
                list_type_samples: _arrayComment
            });
        }
    }

    //*RULES DETERMINATIONS
    const handleSearchRules = (items, _id_exam, _id_profile = null, _key) => {

        console.log({
            muestra: _key,
            exam: _id_exam,
            profile: _id_profile,
            items
        });

        if (!Array.isArray(items)) return;

        // Convertimos todo a string para evitar problemas de comparación
        const ids = items.map(String);

        let _arrayTemp = [...formQuoterMic.list_type_samples];
        let _findType = _arrayTemp[_key];

        if (_findType) {

            _findType.list_determinations = _findType.list_determinations.map(x => {

                const matchExam =
                    (_id_exam && x.id_exam === _id_exam) ||
                    (!_id_exam && x.id_profile === _id_profile);

                if (matchExam) {

                    x.ids_mic_noms = ids;

                    const source =
                        (x.listNorm?.length ?? 0) > 0
                            ? x.listNorm
                            : listRules;

                    x.list_nom = source.filter(n =>
                        ids.includes(String(n.code))
                    );

                    console.log("LIST_NOM FINAL", x.list_nom);

                }

                // if (matchExam) {

                //     x.ids_mic_noms = ids;

                //     if (Array.isArray(x.listNorm)) {

                //         x.list_nom = x.listNorm.filter(n =>
                //             ids.includes(String(n.code))
                //         );

                //         console.log("LIST_NOM FINAL", x.list_nom);

                //         console.log("IDS:", ids);
                //         console.log("LISTNORM:", x.listNorm);
                //         console.log("LIST_NOM:", x.list_nom);

                //     } else {

                //         x.list_nom = [];
                //     }
                // }

                return x;
            });
        }

        setFormQuoterMic(prev => ({
            ...prev,
            list_type_samples: _arrayTemp
        }));
    };
    const openDeleteDeterminacionAlert = (indexSample, id_exam, id_profile, name) => {
        setDeleteType("determination");
        setDetDeleteData({
            indexSample,
            id_exam,
            id_profile,
            name
        });
        setShowDeleteAlert(true);
        setModalAlert(true);
    };

    const saveDeleteDeterminacion = () => {

        const {
            indexSample,
            id_exam,
            id_profile
        } = detDeleteData;

        if (indexSample === null) return;

        let _price = 0;

        let _find =
            formQuoterMic.list_type_samples[indexSample];

        if (_find) {

            let newListTest =
                _find.list_determinations.filter(item => {

                    if (
                        (id_exam !== null &&
                            item.id_exam === parseInt(id_exam))
                        ||
                        (id_profile !== null &&
                            item.id_profile === parseInt(id_profile))
                    ) {

                        _price = item.price_discount;
                        return false;
                    }

                    return true;
                });

            let _list = [...formQuoterMic.list_type_samples];

            let _findDeterminacion =
                _list[indexSample];

            if (_findDeterminacion) {

                _findDeterminacion.list_determinations =
                    newListTest;

                _findDeterminacion.price_sample =
                    parseFloat(
                        (
                            _findDeterminacion.price_sample -
                            _price
                        ).toFixed(2)
                    );
            }

            setFormQuoterMic({
                ...formQuoterMic,
                list_type_samples: _list,
                valid_sampling:
                    newListTest.length > 0
            });
        }

        closeDeleteAlert();
    };

    const closeDeleteAlert = () => {

        setModalAlert(false);
        setShowDeleteAlert(false);

        setSampleDeleteIndex(null);
        setSampleDeleteName("");

        setDeleteType(null);

        setDetDeleteData({
            indexSample: null,
            id_exam: null,
            id_profile: null,
            name: ""
        });
    };

    //*REMOVE TYPE DETERMINACION
    const handleRemoveDeterminacion = (_key, _id_exam, _id_profile = null) => {

        if (_key !== undefined && _key !== "") {

            let _id = parseInt(_key);
            let _price = 0;
            let _find = formQuoterMic.list_type_samples[_id]

            if (_find !== null) {

                let findTest = _find.list_determinations.find(x => (_id_exam !== null ? x.id_exam === parseInt(_id_exam) : x.id_profile === parseInt(_id_profile)));

                if (findTest !== null) {
                    let newListTest = _find.list_determinations.filter(item => {
                        if ((_id_exam !== null && item.id_exam === parseInt(_id_exam)) || (_id_profile !== null && item.id_profile === parseInt(_id_profile))) {
                            _price = item.price_discount;
                            return false;
                        }
                        else {
                            return true;
                        }
                    });
                    let _list = formQuoterMic.list_type_samples;
                    let _findDeterminacion = _list[_key];
                    if (_findDeterminacion) {
                        _findDeterminacion.list_determinations = newListTest;
                        let _priceRemove = _findDeterminacion.price_sample - _price;
                        _findDeterminacion.price_sample = parseFloat(_priceRemove.toFixed(2));
                        _list.map(x => {
                            if (x.id === _findDeterminacion.id) {
                                x = _findDeterminacion;
                            }
                            return x;
                        })
                    }
                    let _valid = _find.list_determinations.length > 0 ? true : false
                    setFormQuoterMic({
                        ...formQuoterMic,
                        list_type_samples: _list,
                        valid_sampling: _valid
                    });
                }
            }
        }
    }

    const openDeleteSampleAlert = (index) => {

        setDeleteType("sample");

        const sample = formQuoterMic.list_type_samples[index];

        setSampleDeleteIndex(index);
        setSampleDeleteName(sample?.name_sample || "");

        setShowDeleteAlert(true);
        setModalAlert(true);
    };


    const saveDeleteSample = () => {

        if (sampleDeleteIndex === null) return;

        const newSamples = [...formQuoterMic.list_type_samples];

        newSamples.splice(sampleDeleteIndex, 1);

        setFormQuoterMic({
            ...formQuoterMic,
            list_type_samples: newSamples
        });

        closeDeleteAlert();
    };

    //*DELETE SAMPLE
    const handleDeleteTypeSample = (_key) => {

        if (_key !== undefined && _key !== "") {

            formQuoterMic.list_type_samples.splice(_key, 1)
            setFormQuoterMic({
                ...formQuoterMic,
                list_type_samples: formQuoterMic.list_type_samples
            });
        }
    }

    //*ADD QUANTITY
    const handleAddQuantity = (_key) => {
        let _listTypeSample = formQuoterMic?.list_type_samples;
        let _findDetermination = _listTypeSample[_key];

        if (_findDetermination) {
            _findDetermination.cant += 1;

            let updatedList = _listTypeSample.map(_x =>
                _x?.id === _findDetermination?.id ? {
                    ..._x,
                    id_new: _findDetermination.id_new
                } : _x
            );
            setFormQuoterMic({
                ...formQuoterMic,
                list_type_samples: updatedList
            });
        }
    }


    //*DELETE QUANTITY
    const handleDeleteQuantity = (_key) => {
        const updatedList = formQuoterMic.list_type_samples.map((item, index) => {
            if (index === _key) {
                return {
                    ...item,
                    cant: Math.max(1, item.cant - 1)
                };
            }
            return item;
        });

        setFormQuoterMic({
            ...formQuoterMic,
            list_type_samples: updatedList
        });
    };


    //*PERCENTAGE DISCOUNTS
    const handleDiscount = (e, _id_exam, _id_profile = null, _key) => {

        if (e !== null && e?.target?.value !== undefined) {

            let _valor = e?.target?.value;
            let _list = formQuoterMic.list_type_samples;
            let _findSample = _list[_key];

            if (_findSample) {
                _findSample.list_determinations.forEach(x => {
                    let _exam = _id_exam !== null && x?.id_exam === _id_exam;
                    let _profile = _id_exam === null && x?.id_profile === _id_profile;

                    if (_exam || _profile) {
                        x.discount_par = _valor;
                    }
                });
            }
            setFormQuoterMic({
                ...formQuoterMic,
                list_type_samples: _list
            });
        }
    }

    //*TOGGLE EXAMS
    const handleToggleExams = () => {
        setModalExams(!modalExams)
    }

    const handleViewExamsProfile = (_key, _id_profile) => {

        if (_key !== undefined && _key !== "") {
            let _findSample = formQuoterMic.list_type_samples[_key];

            if (_findSample) {
                let _find = _findSample.list_determinations.find(x => x.id_profile === parseInt(_id_profile));
                setListExams(_find.listExams);
                handleToggleExams();
            }
        }
    }

    //*DEATIL QUOTER
    const handleViewQuoter = () => {
        setViewQuoter(true);
    }

    const handleClosedQuoter = () => {
        setViewQuoter(false);
    }

    //*CREATE QUATATION
    const saveQuatation = async () => {
        setLoadingCreate(true)

        const listSamplesReady = formQuoterMic.list_type_samples.map(sample => ({
            ...sample,
            list_determinations: sample.list_determinations.map(det => {

                const source =
                    det.listNorm?.length > 0
                        ? det.listNorm
                        : listRules;

                return {
                    ...det,
                    ids_mic_noms: det.ids_mic_noms ?? [],
                    list_nom: source.filter(norm =>
                        (det.ids_mic_noms || [])
                            .map(String)
                            .includes(String(norm.code))
                    )
                };
            })
        }));

        // const listSamplesReady = formQuoterMic.list_type_samples.map(sample => ({
        //     ...sample,
        //     list_determinations: sample.list_determinations.map(det => ({
        //         ...det,
        //         ids_mic_noms: det.ids_mic_noms ?? []
        //     }))
        // }));
        console.log(
            "LISTA A ENVIAR",
            JSON.stringify(listSamplesReady, null, 2)
        );
        const response = await saveQuoter({
            id_company: formQuoterMic.id_company,
            id_patient: formQuoterMic.id_patient,
            id_agreement: formQuoterMic.id_company !== null ? formQuoterMic.id_agreement.value : null,
            date_sample: formQuoterMic.date_sample,
            is_sampling: formQuoterMic.is_sampling,
            id_branch: branch,
            observations: formQuoterMic.observations,
            list_type_samples: listSamplesReady,
            roleUser: roleUser,
            id_address: formQuoterMic.id_address
        });

        if (response.code === 200) {
            if (response.id_quoter > 0) {
                setLoadingCreate(false)
                createSweet("success", "success", "Se genero correctamente la cotización");
                setFormQuoterMic({
                    ...formQuoterMic,
                    statusQuoter: true,
                    id_quatation: response.id_quoter,
                    code_quatation: response.codeQuoter
                });
            }
        }
    }


    const PreviewQuoter = async (_id_quoter, _tax) => {
        const response = await previewPdf({
            id_quoter: formQuoterMic.id_quatation === 0 ? _id_quoter : formQuoterMic.id_quatation,
            print_result: true,
            send_email: false,
            email_client: "",
            tax: total_tax === 0 ? _tax : total_tax
        });

        if (response.code === 200 && response.data) {
            const pdfUrl = URL.createObjectURL(response.data);
            setPdfPreviewQuoter(pdfUrl);
            setShowPreviewPdfQuoter(true);
        } else {
            createSweet("warning", "warning", "No se pudo obtener el PDF");
        }
    };

    const downloadQuoter = async (_id_quoter, _tax) => {
        setLoadingPdfQuoter(true);

        const response = await dowloadPdf({
            id_quoter: formQuoterMic.id_quatation === 0 ? _id_quoter : formQuoterMic.id_quatation,
            print_result: true,
            send_email: false,
            email_client: "",
            tax: total_tax === 0 ? _tax : total_tax
        });

        if (response.code !== 200) {
            createSweet("warning", "warning", "No se descargó el PDF");
        }

        setLoadingPdfQuoter(false);
    };




    const handleNewQuatation = () => {
        setInformationPatient([]);
        setInformationCompany([]);

        setSearchSampleState([]);
        setExamProfileState([]);

        // setListAgreement([]);
        // setListAddress([]);

        setListExams([]);

        setTotal_tax(0);

        setOptionsTotal({
            subtotal: 0,
            tax: 0,
            total: 0
        });

        setViewQuoter(false);

        setFormQuoterMic({
            searchPatientState: [],
            id_company: null,
            id_patient: null,
            id_type_client: null,
            observations: "",
            is_sampling: false,
            date_sample_up: moment().format("D/M/YYYY hh:mm"),
            date_sample: null,
            type_sample_select: null,
            id_exam_temp: null,
            list_type_samples: [],
            statusQuoter: false,
            id_quatation: 0,
            code_quatation: null,
            valid_sampling: false,
            search_quatation: null,
            searchPatientQuoter: [],
            start_date: null,
            end_date: null,
            id_patient_search: null,
            id_company_search: null,
            id_agreement: null,
            id_address: null
        });
    };
    //!SAMPLING
    const handleNavigateSampling = (_code) => {
        history.push("../sanitaria/muestreo/" + _code);
    }

    // ? UPDATE QUOTER------------------------------------------------------

    //*CODE QUATATION   
    const handleChangeSearch = async (e) => {
        const _code = e?.target?.value;

        if (e !== null && e?.target?.value !== undefined) {
            setFormQuoterMic({
                ...formQuoterMic,
                code_quatation: _code
            });
        }
        else {
            setFormQuoterMic({
                ...formQuoterMic,
                code_quatation: null,
            });
        }
    }

    const getSearchQuoter = async (_code_quatation) => {
        if (!_code_quatation) return;

        setLoadingCreate(true);
        try {
            const quoter = await getInformationQuatation(_code_quatation);

            console.log("QUOTER COMPLETO", JSON.stringify(quoter, null, 2));

            if (!quoter) return;

            // DIRECCIONES DE LA EMPRESA
            if (
                quoter.id_company_business_name !== null ||
                quoter.id_address_company !== null
            ) {
                const getList = await getInformationCompany(quoter?.id_company);

                const addressList = [];

                (getList?.listCompanyBusinessNames ?? []).forEach((_find) => {
                    if (_find?.address) {
                        addressList.push({
                            label: _find.address,
                            value: _find.id_company_business_name,
                            id_company_business_name: _find.id_company_business_name
                        });
                    }

                    (_find?.arrayAddressCompany ?? []).forEach((_addr, idx) => {
                        addressList.push({
                            label: _addr?.address ?? "----",
                            value: _addr?.id_address_company ?? idx + 1,
                            id_address_company: _addr?.id_address_company
                        });
                    });
                });

                if (addressList.length === 0) {
                    addressList.push({
                        label: "Por definir",
                        value: 0
                    });
                }

                setListAddress(addressList);
            }
            let _name = "";
            if (quoter.id_patient > 0) {
                (quoter?.patient ?? []).forEach((_find) => {
                    _name = [
                        _find?.name,
                        _find?.paternal_surname,
                        _find?.maternal_surname
                    ].filter(Boolean).join(" ");

                    setInformationPatient({
                        birthday: _find?.birthday ?? "----",
                        phone: _find?.phone ?? "----",
                        email: _find?.email ?? "----",
                        name: _find?.name ?? "----",
                        paternal_surname: _find?.paternal_surname ?? "----",
                        maternal_surname: _find?.maternal_surname ?? "----",
                        client: _name
                    });
                });

                setCheckTypeClient(1);
            } else {
                const listCompany = (quoter?.company ?? []).map((_find) => ({
                    name: _find?.business_name ?? "----",
                    code: _find?.code ?? "----",
                    phone: _find?.phone ?? "----",
                    name_company_turn: _find?.name_company_turn ?? "----",
                    contact_email: _find?.email ?? "----",
                    require_invoice: _find?.require_invoice ? "Si" : "No",
                    payment:
                        _find?.payment_by_company && _find?.payment_by_patient
                            ? "Ambas partes"
                            : _find?.payment_by_company
                                ? "Empresa"
                                : "Paciente"
                }));

                setInformationCompany(listCompany);
                setCheckTypeClient(3);
            }

            // RECUPERAR MUESTRAS Y DETERMINACIONES
            const samplesLoaded = await Promise.all(
                (quoter?.list_type_samples ?? []).map(async (_sample) => {

                    const determinations = await Promise.all(
                        (_sample?.list_determinations ?? []).map(
                            async (_determinations) => {

                                const idsMic = (
                                    _determinations?.ids_mic_noms ?? []
                                ).map(String);

                                let listNormTemp = [];
                                let profileRulesDetail = [];
                                let listExams = [];

                                if (_determinations?.id_profile) {
                                    const getProfileRules =
                                        await getAllRulesByProfile(
                                            _determinations.id_profile
                                        );

                                    profileRulesDetail = getProfileRules ?? [];
                                    listExams = _determinations?.listExams ?? [];

                                    listNormTemp = formatProfileRules(
                                        getProfileRules,
                                        []
                                    ).map(x => ({
                                        code: String(x.code),
                                        name: x.name
                                    }));
                                } else {
                                    const getBiRul = await getAllRulesBiExam(
                                        _determinations?.id_exam ?? 0
                                    );

                                    listNormTemp = Array.isArray(getBiRul)
                                        ? getBiRul.map(_find => ({
                                            code: String(_find?.id_exam_rule),
                                            name: _find?.norm
                                        }))
                                        : [];
                                }

                                return {
                                    id_profile: _determinations?.id_profile ?? null,
                                    id_exam: _determinations?.id_exam ?? null,
                                    price: _determinations?.price ?? 0,
                                    price_discount: _determinations?.price_discount,
                                    name: _determinations?.name ?? "",
                                    code: _determinations?.code ?? "",
                                    abbreviation: _determinations?.code ?? "",
                                    config_iva: _determinations?.config_iva ?? 0,
                                    value_iva: _determinations?.value_iva ?? 0,
                                    id_agreement: _determinations?.id_agreement,
                                    new_determination: _determinations?.new_determination,
                                    discount: _determinations?.discount,
                                    id_quoter_determination:
                                        _determinations?.id_quoter_determination,
                                    observations_det: _determinations?.observations_det,
                                    discount_par: _determinations?.discount_par,
                                    contract_number:
                                        _determinations?.agreement_code ?? "---",
                                    id_price: _determinations?.id_price,
                                    collected_id: _determinations?.collected_id,
                                    not_collected: _determinations?.not_collected,
                                    ids_mic_noms: idsMic,
                                    listNorm: listNormTemp,
                                    profileRulesDetail,
                                    listExams,
                                    list_nom: listNormTemp.filter(x =>
                                        idsMic.includes(String(x.code))
                                    )
                                };
                            }
                        )
                    );

                    // CADA MUESTRA CONSERVA SU PROPIO IDENTIFICADOR
                    return {
                        id: _sample?.id,
                        id_quoter_type_samples:
                            _sample?.id_quoter_type_samples ?? null,
                        id_new: null,
                        list_determinations: determinations,
                        name_sample: _sample?.name_sample,
                        id_type_client: _sample?.id_type_client,
                        observations: _sample?.observations,
                        price_sample: _sample?.price_sample,
                        cant: _sample?.cant ?? 1
                    };
                })
            );

            console.log("MUESTRAS RECUPERADAS", samplesLoaded);

            // FECHA DE LA COTIZACIÓN
            const _fech = quoter?.date_sample
                ? moment(
                    quoter.date_sample,
                    "DD/MM/YYYY HH:mm:ss"
                ).format("YYYY-MM-DD HH:mm:ss")
                : null;

            // ACTUALIZAR TODO EL FORMULARIO UNA SOLA VEZ
            setFormQuoterMic(prev => ({
                ...prev,
                id_patient: quoter?.id_patient,
                searchPatientState: {
                    value: quoter?.id_patient,
                    label: _name
                },
                id_quatation: quoter?.id_quoter,
                observations: quoter?.observations,
                is_sampling: quoter?.is_sampling,
                date_sample: _fech,
                valid_sampling: true,
                id_company: quoter?.id_company,
                code_quatation: _code_quatation,

                id_agreement: quoter?.id_company > 0
                    ? {
                        value: quoter?.id_agreement,
                        label: quoter?.contract_number_agreement
                    }
                    : null,

                id_address:
                    quoter.id_company_business_name === null &&
                        quoter.id_address_company === null
                        ? {
                            value: 0,
                            label: "Por definir"
                        }
                        : {
                            value:
                                quoter?.id_address_company ??
                                quoter?.id_company_business_name,
                            label:
                                quoter?.label_address === ""
                                    ? quoter?.label_bussiness
                                    : quoter?.label_address
                        },

                list_type_samples: samplesLoaded
            }));

        } catch (error) {
            console.error("Error al recuperar la cotización:", error);

            showCustomAlert(
                "error",
                "Error",
                "No fue posible recuperar la información de la cotización."
            );
        } finally {
            setLoadingCreate(false);
        }
    };

    //*UPDATE QUATATION
    const updateQuatation = async () => {

        setLoadingCreate(true);

        const listSamplesReady = formQuoterMic.list_type_samples.map(sample => ({
            ...sample,

            list_determinations: sample.list_determinations.map(det => ({

                ...det,

                ids_mic_noms: det.ids_mic_noms ?? [],

                list_nom: (det.listNorm || []).filter(norm =>
                    (det.ids_mic_noms || [])
                        .map(String)
                        .includes(String(norm.code))
                )
            }))
        }));

        console.log("LISTA PARA ACTUALIZAR", listSamplesReady);

        const response = await updateQuoter({
            id_company:
                formQuoterMic.id_company === null
                    ? 0
                    : formQuoterMic.id_company,

            id_patient: formQuoterMic.id_patient,
            date_sample: formQuoterMic.date_sample,
            is_sampling: formQuoterMic.is_sampling,
            id_branch: branch,
            observations: formQuoterMic.observations,

            list_type_samples: listSamplesReady,

            id_quoter: formQuoterMic.id_quatation,
            updatedatesample: false,
            id_address: formQuoterMic.id_address
        });

        if (response.code === 200) {

            setLoadingCreate(false);

            setFormQuoterMic({
                ...formQuoterMic,
                statusQuoter: true,
            });

            createSweet(
                "success",
                "success",
                "Se actualizó correctamente la cotización"
            );
        }
    }

    //*CONFIGURATION TABLE
    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    const handleExpandRow = (index) => {
        if (expandedRow === index) {
            setExpandedRow(null);
        } else {
            setExpandedRow(index);
        }
    };

    const handleMouseEnterClean = () => {
        setIsHoveredClean(true);
    };

    const handleMouseLeaveClean = () => {
        setIsHoveredClean(false);
    };
    // ? LIST QUATATIONS-----------------------------------------------------

    const handleFilterValues = async (e) => {
        if (e && e?.target?.value !== undefined && e?.target?.value !== "") {

            let _value = e?.target?.value;
            let _name_input = e?.target?.name;

            switch (_name_input) {
                case "start_date":
                    setFormQuoterMic({
                        ...formQuoterMic,
                        start_date: _value,
                    });
                    break;
                case "end_date":
                    setFormQuoterMic({
                        ...formQuoterMic,
                        end_date: _value,
                    });
                    break
                default:
                    setFormQuoterMic({
                        ...formQuoterMic,
                        code_quatation: _value,
                    });
                    break;
            }
        }
    }

    const handleSearchPatient = async (e) => {
        const _code = e?.target?.value;

        if (e !== null && e?.target?.value !== undefined) {
            setFormQuoterMic({
                ...formQuoterMic,
                id_patient_search: _code
            });
        }
        else {
            setFormQuoterMic({
                ...formQuoterMic,
                id_patient_search: null,
            });
        }
    }

    const handleSearchClient = async (e) => {
        const _code = e?.value;
        const _label = e?.label;

        if (e !== null && e?.value !== undefined) {
            setListAgreement([]);

            setFormQuoterMic({
                ...formQuoterMic,
                id_company_search: { value: _code, label: _label }
            });
        }
        else {
            setFormQuoterMic({
                ...formQuoterMic,
                id_company_search: null,
            });
        }
    }

    const handleCleanFilter = () => {

        const today = moment().format("YYYY-MM-DD");

        setFormQuoterMic(prev => ({
            ...prev,
            searchPatientQuoter: [],
            start_date: today,
            end_date: today,
            id_patient_search: null,
            id_company_search: null,
            code_quatation: null,
        }));

        setInformationPatient([]);
        setInformationCompany([]);

        getSearchFilter(`from=${today}&to=${today}`);
    }


    const getFilter = (e, search = true) => {
        e.preventDefault();
        if (search) {

            let _validations = filterValidations(formQuoterMic.start_date, formQuoterMic.end_date, formQuoterMic.id_company_search, formQuoterMic.id_patient_search, formQuoterMic.code_quatation);

            if (_validations !== "") {

                if (_validations === "1" || _validations === "2" || _validations === "3") {

                    if (_validations === "1") {
                        createSweet("warning", "warning", "No se puede hacer la combinación de Empresa y Particular");
                    }
                    else createSweet("warning", "warning", "Se debe seleccionar 2 rangos de fecha");
                    return;
                }
                else getSearchFilter(_validations)
            }
            else createSweet("warning", "warning", "Debes de seleccionar al menos un dato para la busqueda");
        }
    }

    const getSearchFilter = async (_query) => {
        if (_query !== "" && _query !== undefined && _query !== null) {
            setLoadingCreate(true)

            const quoter = await getListQuatations(_query);

            if (quoter.code === 500) {
                setLoadingCreate(false)
                createSweet("warning", "warning", "Cotizaciones", "Sin resulatdos");
                return;
            }

            console.log("🚀 ~ getSearchFilter ~ quoter:", quoter)
            if (quoter !== null) {
                setLoadingCreate(false)
                const list = quoter.map(_find => {
                    const _client = _find.patient.length > 0
                        ? _find.patient.map(_patient => `${_patient?.name || ""} ${_patient?.paternal_surname || ""} ${_patient?.maternal_surname || ""}`).join(" ")
                        : _find.company.map(_company => _company?.business_name || "------").join(" ");

                    const _tax = _find.patient.length > 0
                        ? _find.patient.map(_patient => `${"16"}`).join(" ")
                        : _find.company.map(_company => _company?.border_tax || "16%").join(" ");

                    const _list_determinations = _find.list_type_samples.map(_list => {
                        const _list_exams = _list?.list_determinations.map(_determination => {

                            return {
                                name: _determination?.name,
                                list_nom: _determination?.list_nom,
                                collected_id: _determination?.collected_id,
                                not_collected: _determination?.not_collected,
                                create_at_time: _determination?.create_at_time,
                                is_edit: _determination?.is_edit,
                            }
                        });

                        return {
                            name_sample: _list?.name_sample,
                            list_determinations: _list_exams
                        };
                    });

                    let _taxs = _tax.trim() === "true" ? "8%" : "16%"
                    let _taxsDownload = _tax.trim() === "true" ? 8 : 16


                    return {
                        code_quoter: _find?.code_quoter ?? 0,
                        type: _find?.id_company === null ? "Particular" : "Empresa",
                        client: _client.trim() || "------",
                        date_quoter: _find?.created_at ?? "---",
                        id_quoter: _find?.id_quoter ?? 0,
                        list_determinations: _list_determinations,
                        tax: _taxs || "------",
                        download: _taxsDownload,
                        id_work_order: _find?.id_work_order,
                        nim: _find.nim ?? "---",
                        nameBranch: _find?.label_address?.trim() || "----",
                        date_sample: _find?.date_sample ?? null

                    };
                });
                console.log("🚀 ~ getSearchFilter ~ list:", list)

                setInformationQuatation(list);
            }
            else setInformationQuatation([])
        }
    }

    // ? CONFIGURATION CREATE PATIENT

    const [errorsPatient, setErrorsPatient] = useState({
        name: false,
        paternal_surname: false,
        id_gender: false,
        // phone: false,
        // email_patient: false
    });

    const cleanPatientErrors = () => {
        setErrorsPatient({
            name: false,
            paternal_surname: false,
            id_gender: false,
            // phone: false,
            // email_patient: false
        });
    };

    const tooglePatient = () => {

        if (modalPatient) {
            cleanPatientErrors();
        }

        setModalPatient(!modalPatient);
    };

    const handleCreatePatient = () => {
        tooglePatient()
    }

    const handleInformationPatient = (e, _nameInput) => {
        if (e !== undefined && e !== null) {
            if (e && _nameInput) {
                setErrorsPatient(prev => ({
                    ...prev,
                    [_nameInput]: false
                }));
                setFormPatient({
                    ...formPatient,
                    [_nameInput]: e?.target?.value
                });
            }
        }
    }



    const savePatient = async () => {
        setLoadingPatientMicro(true)

        const errors = {
            name: !formPatient.name?.trim(),
            paternal_surname: !formPatient.paternal_surname?.trim(),
            id_gender: formPatient.id_gender === 0,
            // phone: !formPatient.phone?.trim(),
            // email_patient: !formPatient.email_patient?.trim()
        };

        setErrorsPatient(errors);

        if (Object.values(errors).some(x => x)) {
            setLoadingPatientMicro(false);
            return;
        }

        const response = await savePatientMicro({
            id_gender: formPatient?.id_gender,
            id_state_patient: formPatient?.id_state_patient,
            id_municipality_patient: formPatient?.id_municipality_patient,
            id_social_gender_patient: formPatient?.id_social_gender_patient,
            id_blood_type: formPatient?.id_blood_type,
            id_tax_regime: formPatient?.id_tax_regime,
            id_use_cfdi: formPatient?.id_use_cfdi,
            paternal_surname: formPatient?.paternal_surname,
            maternal_surname: formPatient?.maternal_surname,
            name: formPatient?.name,
            birthday: formPatient?.birthday,
            age: formPatient?.age,
            curp: formPatient?.curp,
            address_patient: formPatient?.address_patient,
            cp_patient: formPatient?.cp_patient,
            colony_patient: formPatient?.colony_patient,
            phone: formPatient?.phone,
            email_patient: formPatient?.email_patient,
            membership: formPatient?.membership,
            cardnumber: formPatient?.cardnumber,
            rfc: formPatient?.rfc,
            type_person: formPatient?.type_person,
            new_social_gender: formPatient?.new_social_gender,
            scan_ine_check: formPatient?.scan_ine_check,
            setFileINE: formPatient?.setFileINE,
            nss: formPatient?.nss,
            matricula_buap: formPatient.matricula_buap

        });


        if (response.code === 200) {
            setLoadingPatientMicro(false)
            createSweet("success", "success", "Se creo correctamente el paciente");
            tooglePatient()
            setFormPatient({
                ...formPatient,
                id_gender: 0,
                id_state_patient: 1,
                id_municipality_patient: 1,
                id_social_gender_patient: null,
                id_blood_type: null,
                id_tax_regime: null,
                id_use_cfdi: null,
                paternal_surname: null,
                maternal_surname: null,
                name: null,
                birthday: "2025-01-01",
                age: 0,
                curp: "CURPDEFAULT",
                address_patient: "DEFAULT",
                cp_patient: "00000",
                phone: null,
                email_patient: null,
                membership: "0",
                cardnumber: "DEFAULT",
                rfc: "DEFAULT",
                type_person: 1,
                new_social_gender: "",
                scan_ine_check: false,
                setFileINE: "DEFAULT",
                nss: 0
            });
        }
    }

    // * PDF LIST SAMPLING
    const handleDownloadPdf = async (_id_quoter = 0, _code_quoter) => {
        let data = {
            id_quoter: _id_quoter,
            print_result: true,
            send_email: false,
            email_client: ""
        };
        console.log("🚀 ~ handleDownloadPdf ~ data:", data)

        let raw = JSON.stringify(data);
        let token = localStorage.getItem("token");

        const response = await fetch(
            ConfigServer.serverUrl + "/api/QuoterDeterminations/CreateDocumentSamplingSheet",
            {
                method: 'POST',
                body: raw,
                headers: {
                    "Authorization": "Bearer " + token,
                    "Content-Type": "application/json"
                }
            }
        );

        if (response.status !== 200) {
            createSweet("warning", "warning", "No se descargó el PDF");
            return;
        }

        const blob = await response.blob();

        const pdfUrl = URL.createObjectURL(blob);
        setPdfPreviewSamplingSheet(pdfUrl);
        setShowPreviewSamplingSheet(true);

        const link = document.createElement("a");
        link.href = pdfUrl;
        link.setAttribute("download", `Hoja de Toma y Custodia-${_code_quoter}.pdf`);
        document.body.appendChild(link);
        link.style.display = 'none';
        link.click();

        createSweet("success", "success", "Descargando", "Se descargó el PDF");
    };

    const downdloadpdfSampling = async (_id_quoter = 0, _code_quoter) => {
        setCurrentQuoter(_id_quoter);
        setCurrentCode(_code_quoter);

        let data = {
            id_quoter: _id_quoter,
            print_result: true,
            send_email: false,
            email_client: ""
        };

        let raw = JSON.stringify(data);
        let token = localStorage.getItem("token");

        const response = await fetch(
            ConfigServer.serverUrl + "/api/QuoterDeterminations/CreateDocumentSamplingSheet",
            {
                method: 'POST',
                body: raw,
                headers: {
                    "Authorization": "Bearer " + token,
                    "Content-Type": "application/json"
                }
            }
        );

        if (response.status !== 200) {
            createSweet("warning", "warning", "No se pudo obtener el PDF");
            return;
        }

        const blob = await response.blob();

        const pdfUrl = URL.createObjectURL(blob);
        setPdfPreviewSamplingSheet(pdfUrl);
        setShowPreviewSamplingSheet(true);

        // createSweet("success", "success", "Vista previa lista", "El PDF está disponible en el modal");
    };



    // * ACTIONS
    const navigateUpdate = (_workOrderId) => {
        history.push(`../admisiones/${_workOrderId}/editar`);
    }

    const navigateIngress = (nim) => {
        let _nim = nim
        history.push(`../sanitaria/recepcion/${_nim}`);
    }


    // console.log("estrela",formQuoterMic);

    //* count 

    const handleChangeQuantity = (_key, value) => {

        if (value < 1 || isNaN(value)) value = 1;

        let _list = [...formQuoterMic.list_type_samples];

        if (_list[_key]) {
            _list[_key].cant = value;

            setFormQuoterMic({
                ...formQuoterMic,
                list_type_samples: _list
            });
        }
    };


    //* DIALOG NORMS

    const handleViewNorms = (det) => {

        setDetailNorm(det);
        setModalNorms(true);
    };

    const handleToggleNorms = () => {
        setModalNorms(!modalNorms);
    };

    //* COUNT SAMPLE AND DETERMINATIONS
    const totalSample = formQuoterMic.list_type_samples.reduce(
        (total, sample) => total + (sample.cant || 1),
        0
    );
    const totalDeterminations = formQuoterMic.list_type_samples.reduce(
        (total, sample) =>
            total +
            ((sample.list_determinations?.length || 0) * (sample.cant || 1)),
        0
    );
    //* CLEAR TABS

    const cleanQuoter = () => {

        setInformationPatient([]);
        setInformationCompany([]);
        setListAddress([]);
        setListAgreement([]);

        setOptionsTotal({
            subtotal: 0,
            tax: 0,
            total: 0
        });

        setFormQuoterMic({
            searchPatientState: [],
            id_company: null,
            id_patient: null,
            id_type_client: null,
            observations: "",
            is_sampling: false,
            date_sample_up: moment().format("D/M/YYYY hh:mm"),
            date_sample: null,
            type_sample_select: null,
            id_exam_temp: null,
            list_type_samples: [],
            statusQuoter: false,
            id_quatation: 0,
            code_quatation: null,
            valid_sampling: false,
            search_quatation: null,
            searchPatientQuoter: [],
            start_date: null,
            end_date: null,
            id_patient_search: null,
            id_company_search: null,
            id_agreement: null,
            id_address: null
        });

        setViewQuoter(false);
    };

    const handleGoBack = () => {
        history.goBack();
    }


    //? clear determination ans sample table
    const clearQuotationData = () => {

        setSearchSampleState([]);
        setExamProfileState([]);

        setOptionsTotal({
            subtotal: 0,
            tax: 0,
            total: 0
        });

        setFormQuoterMic(prev => ({
            ...prev,
            list_type_samples: [],
            valid_sampling: false,
            type_sample_select: null,
            id_exam_temp: null
        }));
    };

    return {
        // * TYPE CLIENT
        handleChangeTypeClient, checkTypeClient, handleChangePatient, informationPatient, listCompanies, handleChangeCompany, informationCompany,
        listAddress, handleChangeAddress,

        // * QUOTER
        handleChangeComments, handlePickerValues, handleChangeSampling,

        // * TYPE OF SAMPLE
        handleSelectDetermination, searchSampleState, examProfileState, handleSelectMuestra,

        // * FORM MIC
        formQuoterMic,

        // * ACTION TYPE SAMPLE
        handleDeleteTypeSample, handleAddQuantity, handleDeleteQuantity,

        // * TABLE
        handleObservations, listRules, handleSearchRules, handleRemoveDeterminacion, handleDiscount,

        // * TOGGLE EXAMS
        handleToggleExams, handleViewExamsProfile, modalExams, listExams,

        // * PRICES
        optionsTotal, total_tax,

        // * VIEW QUOTER
        handleViewQuoter, handleClosedQuoter, viewQuoter, nameBranch, loadingCreate,

        // * CREATE AND ACTIONS
        saveQuatation, downloadQuoter, handleNewQuatation, handleNavigateSampling,

        // * UPDATE QUOTER
        handleChangeSearch, getSearchQuoter, updateQuatation,

        // * CONFIGURATION BUTTONS
        isHovered, handleMouseEnter, handleMouseLeave, handleMouseEnterClean, handleMouseLeaveClean, isHoveredClean,

        // * CONFIGURATION TABLE
        informationQuatation, handleExpandRow, hoveredColumn, setHoveredColumn, expandedRow,

        //  *FILTER
        handleFilterValues, handleSearchPatient, handleSearchClient, getFilter, handleCleanFilter,

        // * AGREEMENT
        listAgreement, handleChangeAgreement,

        // * CREATE PATIENT
        modalPatient, tooglePatient, handleCreatePatient, formPatient, handleInformationPatient, savePatient, loadingPatientMicro, errorsPatient,

        url_helen, downdloadpdfSampling, navigateUpdate, navigateIngress,

        //* PDF QUOTER PREVIEW

        pdfPreviewQuoter, showPreviewPdfQuoter, setShowPreviewPdfQuoter, setPdfPreviewQuoter, loadingPdfQuoter, PreviewQuoter,

        //* PDF Sampling Sheet
        showPreviewSamplingSheet, setShowPreviewSamplingSheet, setPdfPreviewSamplingSheet, pdfPreviewSamplingSheet, handleDownloadPdf, loadingPdf,
        currentCode, currentQuoter,

        //* MODAL ALERT NOM
        showAlertNorma, setShowAlertNorma, messageNorma, setMessageNorma,

        //* CPUNT NUMBER TABLE
        handleChangeQuantity,

        //* DIALOG NORM 

        handleViewNorms, listNorms, modalNorms, handleToggleNorms, detailNorm,

        //* DELETE SAMPLE
        openDeleteSampleAlert, saveDeleteSample, closeDeleteAlert, showDeleteAlert, modalAlert, sampleDeleteName,

        //* DELETE DETERMINATIONS
        deleteType, saveDeleteDeterminacion, detDeleteData, openDeleteDeterminacionAlert,

        //* COUNT SAMPLE AND DETERMINATIONS
        totalSample, totalDeterminations,

        //* CLEAR TABS
        cleanQuoter,

        handleGoBack,

        //* CLEAR QUOTATIONS
        clearQuotationData,

        //?  CUSTOM ALERT DIALOG
        customAlert,

    }
}
